module.exports = "/_next/static/images/DataOpsObservabilityConf2-59db0386b17e5b2e110793d950840482.jpg";